import {
  AuditOutlined,
  BankOutlined,
  ContactsOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  HomeOutlined,
  LockOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Button,
  QRCode,
  Skeleton,
  Table,
  Typography,
  notification,
} from "antd";
import { useState, useCallback, useEffect, useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { LanguageContext } from "../../../context/Language.contex";

const { Title, Paragraph } = Typography;

export const ViewVisitor = () => {
  const [data, setData] = useState(null);
  const { id } = useParams();
  const { language } = useContext(LanguageContext);

  // Fetch data visitor dari API
  const fetchData = useCallback(async () => {
    try {
      const res = await axios.get(
        `https://cmi-general-platform-be.vercel.app/visitor/${id}`
      );
      console.log(res.data);
      const userData = {
        ...res.data?.data,
      };
      setData(userData);
    } catch (error) {
      console.error("Error fetching visitor data:", error);
    }
  }, [id]);

  useEffect(() => {
    if (data === null) {
      fetchData();
    }
  }, [data, fetchData]);

  // Fungsi untuk mendownload file
  function doDownload(url, fileName) {
    const a = document.createElement("a");
    a.download = fileName;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // Fungsi untuk mendownload QR Code sebagai PNG
  const downloadCanvasQRCode = () => {
    const canvas = document.getElementById("myqrcode")?.querySelector("canvas");
    if (canvas) {
      const url = canvas.toDataURL("image/png"); // Konversi canvas ke URL gambar PNG
      doDownload(url, "QRCode.png");
    } else {
      console.error("Canvas element not found!");
    }
  };

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const copyToClipboard = async (text) => {
    if ("clipboard" in navigator) {
      await navigator.clipboard.writeText(text);
      api["info"]({
        message: "Berhasil dicopy",
      });
    } else {
      // Fallback for browsers without Clipboard API support
      // You can use a library like copy-to-clipboard here
      // For example:
      // const copy = require('copy-to-clipboard');
      // copy(text);
    }
  };

  const [api, contextHolder] = notification.useNotification();

  return (
    <>
      {contextHolder}
      <div
        style={{
          display: isMobile ? "block" : "flex",
          justifyContent: "space-evenly",
        }}
      >
        {/* Bagian Barcode */}
        <div
          style={{
            textAlign: "center",
            justifyItems: "center",
          }}
        >
          <h1>{language[37]}</h1>
          <QRCode
            id="myqrcode"
            size={150}
            errorLevel="H"
            value={`${data?.code}`}
            style={{
              color: "white",
              fontSize: 50,
              margin: "auto 0",
              border: "2px solid #2C74B3",
            }}
            bgColor="#fff"
            type="canvas"
          />
          <br />
          <br />
          <Button type="primary" onClick={downloadCanvasQRCode}>
            {language[38]}
          </Button>
        </div>

        {/* Bagian Biodata Visitor */}
        <div
          style={{
            textAlign: "center",
            justifyItems: "center",
          }}
        >
          <h1>{language[29]}</h1>
          <h1>{data?.name}</h1>
          <span
            style={{
              color: "red",
              fontSize: "20px",
              fontWeight: "bold",
              animation: "blink 1s infinite",
            }}
          >
            - {language[39]} -
          </span>

          {data !== null ? (
            <>
              <table style={{ textAlign: "left" }}>
                <tbody>
                  <tr>
                    <th>{language[40]}</th>
                    <td>
                      {data?.code}{" "}
                      <Button
                        onClick={() => {
                          copyToClipboard(data?.code);
                        }}
                      >
                        Copy
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <th>Name</th>
                    <td>{data?.detail_name}</td>
                  </tr>
                  <tr>
                    <th>{language[8]}</th>
                    <td>{data?.detail_institution}</td>
                  </tr>
                  <tr>
                    <th>{language[6]}</th>
                    <td>{data?.detail_address}</td>
                  </tr>

                  <tr>
                    <th>{language[7]}</th>
                    <td>{data?.detail_phone}</td>
                  </tr>
                  <tr>
                    <th>{language[9]}</th>
                    <td>{data?.detail_description}</td>
                  </tr>
                  <tr>
                    <th>{language[10]}</th>
                    <td>{data?.detail_appointment}</td>
                  </tr>

                  <tr>
                    <th>{language[15]}</th>
                    <td>{data?.approver_username ?? "- not yet approved -"}</td>
                  </tr>
                </tbody>
              </table>
            </>
          ) : (
            <>
              <Skeleton />
              <Button type="primary" disabled>
                Loading...
              </Button>
            </>
          )}
        </div>
      </div>
      {/* Bagian Tabel Visitor Lists - sekarang di bawah barcode dan biodata */}
      <div
        style={{
          marginTop: "28px",
          padding: "18px 18px 28px 18px",
          border: "1px solid #e0e0e0",
          borderRadius: "16px",
          background: "linear-gradient(90deg,#f6f8fa 60%,#eaf6f6 100%)",
          boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
          maxWidth: 700,
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <h2
          style={{
            textAlign: "left",
            fontSize: 22,
            fontWeight: 700,
            color: "#088395",
            marginBottom: 18,
          }}
        >
          List of Visitors
        </h2>
        {data?.visitor_list && data.visitor_list.length > 0 ? (
          <Table
            dataSource={data.visitor_list.map((item, idx) => ({
              key: item.id || idx,
              name: item.name,
              nik: item.nik,
            }))}
            columns={[
              {
                title: (
                  <span
                    style={{
                      color: "#41B3A2",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    Name
                  </span>
                ),
                dataIndex: "name",
                key: "name",
                render: (text) => (
                  <span style={{ fontWeight: 500 }}>{text}</span>
                ),
              },
              {
                title: (
                  <span
                    style={{
                      color: "#41B3A2",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    NIK
                  </span>
                ),
                dataIndex: "nik",
                key: "nik",
                render: (text) => (
                  <span style={{ fontWeight: 500 }}>{text}</span>
                ),
              },
            ]}
            pagination={false}
            size="middle"
            bordered
            style={{ borderRadius: 12, overflow: "hidden" }}
            rowClassName={(_, idx) =>
              idx % 2 === 0 ? "ant-table-row-light" : "ant-table-row-dark"
            }
          />
        ) : (
          <p
            style={{
              textAlign: "center",
              fontStyle: "italic",
              color: "#888",
            }}
          >
            No visitor lists available.
          </p>
        )}
      </div>
    </>
  );
};
